import { AppProvider } from './app.provider'
import { AuthProvider } from '../contexts/auth.context'
import { UserProvider } from '../contexts/user.context'

interface StoreProviderProps {
  children: React.ReactNode
}

export function StoreProvider({ children }: StoreProviderProps) {
  return (
    <AuthProvider>
      <UserProvider>
        <AppProvider>{children}</AppProvider>
      </UserProvider>
    </AuthProvider>
  )
}
